import React, { useEffect, useState } from "react";
import TicketsDropdown from "./TicketsDropdown";
import { CustomModal } from "../../../../revampComponents/Atom/Modals";
import AddSingleRegistrationForm from "./AddSingleRegistrationForm";
import AccessCodeDropdown from "./AccessCodeDropdown";
import { dashboardColors, theme } from "../../../../themes/Theme";

const AddSingleRegistration = ({
  eventId,
  showAddRegistrationModal,
  setShowAddRegistrationModal,
  setShowFormModal,
  setSelectedTicket,
  selectedTicket,
  prop,
  registrationUrl,
  setRegistrationUrl,
  selectedAccessCode,
  setSelectedAccessCode
}) => {
  const [ticketsData, setTicketsData] = useState([]);
  const handleProceedClick = () => {
    if (!selectedTicket?.value) return;
    const eventUrl = prop.eventInfo.event_url;
    const ticketId = selectedTicket.value;
    setShowAddRegistrationModal(false);
    setShowFormModal(true);
  };
  return (
    <div>
      <p className="select-ticket-single-registration">
        Select ticket for adding single registration
      </p>
      <p className="ticket-name-single-registration mb-1">Ticket Name</p>
      <TicketsDropdown
        setSelectedTicket={setSelectedTicket}
        selectedTicket={selectedTicket}
        eventId={eventId}
        setTicketsData={setTicketsData}
        ticketsData={ticketsData}
      />
      {selectedTicket?.isHidden && <div className="mt-3 ">
        <p className=" mb-1 ticket-name-single-registration">Select Access Code</p>
        <AccessCodeDropdown
          setSelectedTicket={setSelectedTicket}
          selectedTicket={selectedTicket}
          eventId={eventId}
          setTicketsData={setTicketsData}
          ticketsData={ticketsData}
          selectedAccessCode={selectedAccessCode} setSelectedAccessCode={setSelectedAccessCode}
        />
      </div>}
      <p className=" mt-3 single-registration-note d-flex flex-column align-items-start">
        <b className="mt-1 ">Note: </b>
        <ul className="p-3  mb-0">
          <li>
            Paid ticket registrations added manually will be considered free.
            Collect payment offline if needed.
          </li>
          <li className="mt-1">
            To send a registration confirmation email to the attendee, please
            ensure that the email confirmation checkbox (visible in the next
            step) is selected before proceeding
          </li>
        </ul>
      </p>

      <div className="py-3 justify-content-end row w-100 m-0 d-flex">
        <button
          type="button"
          className="k-btn cancel-btn mr-0 mr-sm-3 mt-3 mt-sm-0 position-relative"
          onClick={() => {
            setShowAddRegistrationModal(false);
            setSelectedTicket(null);
          }}
        >
          Cancel
        </button>
        <button
          type="button"
          className="k-btn save-btn mt-3 mt-sm-0 ml-3 ml-sm-0 position-relative"
          onClick={handleProceedClick}
          disabled={
            !selectedTicket?.value ||
            ticketsData.length === 0 ||
            (selectedTicket?.isHidden && !selectedAccessCode)
          }
        >
          Proceed
        </button>
      </div>
      <style>
        {`
      .select-ticket-single-registration{
        font-size:18px;
        color: ${dashboardColors[theme].primaryTextColor};
        font-weight:500;
      }
      .ticket-name-single-registrationz{
        font-size:15px;
        color: ${dashboardColors[theme].primaryTextColor};
        font-weight:400;
      }
      .single-registration-note{
        background: #F8F8F8;
        border: 1px solid #E2E2E2;
        border-radius: 4px;
        font-size: 15px;
        color: #333333;
        font-weight: 400;
        padding: 20px !important;
      }
      .noteText{
        font-size: 14px;
      }
      
      `}
      </style>
    </div>
  );
};

export default AddSingleRegistration;
